export default __webpack_public_path__ + "static/media/golf-city-1.08cc7d41.jpg";